<template lang="pug">
  .advance-settings
    v-container.px-0(style="max-width:600px")
      v-expansion-panels(accordion flat)
        v-expansion-panel.border-bottom
          v-expansion-panel-header
            template(v-slot:default='{ open }')
              div
                div.s1.basic800--text {{ $t('intergrations') }}
                div.c1.basic600--text {{ $t('intergrations_desc') }}
          v-expansion-panel-content
            v-card.py-4.mt-4(flat outlined)
              .header.px-4
                div.s1.basic800--text {{ $t('analytics') }}
                div.c1.basic600--text {{ $t('analytics_desc') }}
                div.c1.accent--text(@click="openLink('a')") {{ $t('learn_more') }}

              v-divider.my-4
              v-layout.mx-4.mt-4
                div.my-auto
                  v-card.elevation-0
                    v-img(:src="require('@/assets/images/settings/logo_facebook_pixel.svg')" width=28)
                div.my-auto.ml-3.s1.basic800--text Facebook Pixel
                v-spacer
                v-chip.text-uppercase.button-AA-tiny(label outlined color="black" small @click="openTrackerDialog('fb')") {{ $t('manage') }}
              v-divider.my-4
              v-layout.mx-4.mt-4
                div.my-auto.ml-1
                  v-card.elevation-0
                    v-img(:src="require('@/assets/images/settings/logo_analytics.svg')" width=19 contain)
                div.my-auto.ml-4.s1.basic800--text Google Analytics
                v-spacer
                v-chip.text-uppercase.button-AA-tiny(label outlined color="black" small @click="openTrackerDialog('ga')") {{ $t('manage') }}

            v-card.py-4.mt-4(flat outlined)
              .header.px-4
                div.s1.basic800--text {{ $t('e_commerce_integrations') }}
                div.c1.basic600--text {{ $t('e_commerce_integrations_desc') }}
                div.c1.accent--text(@click="openLink('e')") {{ $t('learn_more') }}

              div(v-for="ecomm in ecommerce" :key="ecomm.title")
                v-divider.my-4
                v-layout.mx-4
                  div.my-auto
                    v-card.elevation-0
                      v-img(:src="ecomm.image" width=28)
                  div.my-auto.ml-3.body-2 {{ ecomm.title }}
                  v-spacer
                  v-chip.text-uppercase.button-AA-tiny(v-if="ecomm.action === 'router-push'" label outlined color="black" small @click="setUp(ecomm.link)") {{ $t('manage') }}

            v-card.py-4.mt-4(flat outlined)
              .header.px-4
                div.s1.basic800--text {{ $t('domain') }}
                div.c1.basic600--text {{ $t('domain_desc') }}
                //- div.c1.basic600--text(v-if="$store.state.subscriptions.feature === 'free'") Manage your domain for Donation Form

              v-divider.my-4
              v-layout.mx-4.mt-4
                div.my-auto.s1.basic800--text {{ $t('custom_domain') }}
                v-spacer
                v-chip.text-uppercase.button-AA-tiny(label outlined color="black" small @click="openRequestCustDomain = true") {{ $t('manage') }}

              v-divider.my-4
              v-layout.mx-4.mt-4
                div.my-auto.s1.basic800--text {{ $t('domain_verifications') }}
                v-spacer
                v-chip.text-uppercase.button-AA-tiny(label outlined color="black" small @click="openDomainVerifications = true") {{ $t('manage') }}

            v-card.py-4.mt-4(flat outlined)
              v-layout.mx-4
                .header
                  div.s1.basic800--text {{ $t('webhook') }}
                  div.c1.basic600--text {{ $t('webhook_desc') }}
                  div.c1.accent--text(@click="openLink('w')") {{ $t('learn_more') }}
                v-spacer
                v-chip.my-auto.text-uppercase.button-AA-tiny(label outlined color="black" small @click="openWebhookDialog()") {{ $t('manage') }}
          v-divider.basic300

      v-expansion-panels(accordion flat)
        v-expansion-panel.border-bottom
          v-expansion-panel-header
            template(v-slot:default='{ open }')
              div
                div.s1.basic800--text {{ $t('shipping_and_delivery') }}
                div.c1.basic600--text {{ $t('shipping_and_delivery_desc') }}

          v-expansion-panel-content

            //- Shipping zone
            v-card.py-4.mt-4(flat outlined)
              div.px-4.pb-4
                div.s1.basic800--text {{ $t('section_title_zone') }}
                div.c1.basic600--text {{ $t('section_desc_zone') }}
                a.c1.accent--text.text-decoration-none(href="https://help.yezza.io/hc/en-my/articles/900003730746-How-To-Setup-Manual-Delivery" target="_blank") {{ $t('learn_more') }}
              delivery-zone-list(:open.sync="openManageDeliveryZoneDialog" :company="company" :couriers="couriers")

    .modals
      update-trackers(v-if="showUpdateTrackersDialog" :open.sync="showUpdateTrackersDialog" :company.sync="company" :type="openTrackerType")
      update-webhook(v-if="showUpdateWebhookDialog" :open.sync="showUpdateWebhookDialog" :company="company")
      request-custom-domain(v-if="openRequestCustDomain" :open.sync="openRequestCustDomain" :company="company")
      domain-verifications(v-if="openDomainVerifications" :open.sync="openDomainVerifications" :company="company")

</template>

<script>
import { mapActions } from 'vuex'
import UpdateTrackers from '@/components/dialogs/settings/UpdateTrackers.vue'
import UpdateWebhook from '@/components/dialogs/settings/UpdateWebhook.vue'
import RequestCustomDomain from '@/components/dialogs/RequestCustomDomain.vue'
import DomainVerifications from '@/components/dialogs/DomainVerifications.vue'
import OnlinePaymentList from '@/components/settings/OnlinePaymentList.vue'
import DeliveryChargeList from '@/components/dialogs/settings/DeliveryChargeList.vue'
import DeliveryZoneList from '@/components/dialogs/settings/DeliveryZoneList.vue'

export default {
  name: 'AdvanceConfigurationSettings',
  components: { UpdateTrackers, UpdateWebhook, RequestCustomDomain, DomainVerifications, OnlinePaymentList, DeliveryChargeList, DeliveryZoneList },
  props: ['company'],
  data () {
    return {
      paymentExpansionPanels: undefined,
      showUpdateTrackersDialog: false,
      showUpdateWebhookDialog: false,
      openRequestCustDomain: false,
      openDomainVerifications: false,
      openTrackerType: '',
      ecommerce: [
        { title: 'WooCommerce', image: require('@/assets/images/settings/logo_woocommerce.svg'), link: '/admin/settings/woocommerce', action: 'router-push' },
        // { title: 'Magento', image: require('@/assets/images/magento-logo-square.png'), link: '/admin/settings/woocommerce', action: 'dialog' },
        { title: 'Shopify', image: require('@/assets/images/settings/logo_shopify.svg'), link: '/admin/settings/shopify', action: 'router-push' },
      ],
      openManageDeliveryZoneDialog: false,
      couriers: []
    }
  },
  mounted () {
    this.fetchShippingSettings()
    this.handleClickFromYezzaPayNoticeBanner()
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    openLink (link) {
      if (link === 'w') {
        window.open('https://guide.yezza.io/eng/tips-use-webhook/')
      } else if (link === 'a' ) {
        window.open('https://help.yezza.io/hc/en-my/sections/900000600066-Analytics')
      } else if (link === 'p' ) {
        window.open('https://help.yezza.io/hc/en-my/categories/900000227246-Accept-Payments')
      } else {
        window.open('https://help.yezza.io/hc/en-my/articles/900003297906-How-To-Integrate-Yezza-With-WooCommerce-')
      }
    },
    setUp (path) {
      if (!this.Auth('root', 'e_commerce_integrations')) {
        this.showMessage(['upgrade'])
        return
      }
      this.$router.push(path)
    },
    openTrackerDialog (type) {
      this.openTrackerType = type
      this.showUpdateTrackersDialog = true
    },
    openWebhookDialog () {
      //this.openTrackerType = type
      this.showUpdateWebhookDialog = true
    },
    toggleCourier(courier) {
      const data = {'enabled': this.couriers[courier].enabled}
      this.axios.patch(`/shipping/settings/${this.company.slug}/${courier}`, data)
        .then(() => {
          const shipments = {
            easyparcel: this.couriers.easyparcel.enabled,
            zepto: this.couriers.zepto.enabled,
            lalamove: this.couriers.lalamove.enabled,
            yscourier: false,
            yslocaldelivery: false
          }
          this.$store.commit('orders/setShipments', shipments)
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
    },
    openCourier (courier) {
      if (courier === 'easyparcel') {
        this.$router.push('/admin/settings/easyparcel')
      } else if (courier === 'zepto') {
        this.$router.push('/admin/settings/zeptoexpress')
      } else if (courier === 'lalamove') {
        this.$router.push('/admin/settings/lalamove')
      }
    },
    getAvailability (index) {
      return this.couriers[index].available
    },
    fetchShippingSettings () {
      this.$axios.get(`/shipping/settings/${this.company.slug}`).then((response) => {
        this.couriers = response.data.couriers
      },()=>{})
    },
    handleClickFromYezzaPayNoticeBanner () {
      if (this.$store.state.ui.securepayMigrateModal) {
        this.paymentExpansionPanels = 0
      }
      this.$watch('$store.state.ui.securepayMigrateModal', (val) => {
        if (val) {
          this.paymentExpansionPanels = 0
        }
      })
    }
  }
}
</script>

<i18n>
{
  "en": {
    "section_title_zone": "Manage shipping & delivery methods by zones",
    "section_desc_zone": "Manage shipping & delivery methods by zones",
    "section_title_courier": "Courier Integration",
    "section_desc_courier": "Take advantage of courier services that can easily integrated with your Yezza account",
    "section_title_ondemand": "On-Demand Delivery Integration",
    "section_desc_ondemand": "Take advantage of on-demand delivery services that can easily integrated with your Yezza account",
    "courier_description": {
      "easyparcel": "Hub for major courier services like PosLaju, DHL etc.",
      "lalamove": "On-Demand service delivery in Malaysia",
      "zepto": "On-Demand service delivery in Malaysia"
    },
    "intergrations": "Integrations",
    "intergrations_desc": "Analytics, e-commerce integrations, domain, webhook",
    "analytics": "Analytics",
    "analytics_desc": "Analyze and measure your business performance",
    "e_commerce_integrations": "E-commerce Integrations",
    "e_commerce_integrations_desc": "Integrate with your current e-commerce system",
    "domain": "Domain",
    "domain_desc": "Manage your domain for Whatsapp Form and Yezza Store",
    "custom_domain": "Custom Domain",
    "domain_verifications": "Domain Verifications",
    "webhook": "Webhook",
    "webhook_desc": "Webhook setting for API integration",
    "shipping_and_delivery": "Shipping and delivery",
    "shipping_and_delivery_desc": "Manage zones, courier and on-demand integrations"
  },
  "id": {
    "section_title_zone": "Kelola pengiriman mengikut zona",
    "section_desc_zone": "",
    "section_title_courier": "Integrasi dengan kurier",
    "section_desc_courier": "",
    "section_title_ondemand": "Pengiriman hari sama",
    "section_desc_ondemand": "",
    
    "intergrations": "Integraso",
    "intergrations_desc": "Analitik, integrasi e-niaga, domain, webhook",
    "analitik": "Analitik",
    "analytics_desc": "Analisis dan ukur kinerja bisnis kamu",
    "e_commerce_integrations": "Integrasi E-niaga",
    "e_commerce_integrations_desc": "Terintegrasi dengan sistem e-niaga kamu saat ini",
    "domain": "Domain",
    "domain_desc": "Kelola domain kamu untuk form Whatsapp dan Toko Yezza",
    "domain_kustom": "Domain Kustom",
    "domain_verifications": "Verifikasi Domain",
    "webhook": "webhook",
    "webhook_desc": "Pengaturan webhook untuk integrasi API",
    "shipping_and_delivery": "Pengiriman dan pengiriman",
    "shipping_and_delivery_desc": "Kelola zona, kurir, dan integrasi sesuai permintaan"
  }
}
</i18n>
